"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return typeof Map !== 'undefined' && value instanceof Map;
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/isMap.js
// module id = 335
// module chunks = 0